/* @flow */
export const FETCH_ALERT_NAME_LIST: string = 'FETCH_ALERT_NAME_LIST';
export const FETCH_ALERT_NAME_LIST_SUCCESS: string = 'FETCH_ALERT_NAME_LIST_SUCCESS';
export const FETCH_ALERT_NAME_LIST_ERROR: string = 'FETCH_ALERT_NAME_LIST_ERROR';
export type AlertNameListTypeAction = {
    type: string,
    payload?: Object,
};
